module.exports = __webpack_public_path__ + "static/img/index.1db472a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/P12H/index.png
// module id = w8mK
// module chunks = 0